import AxiosClient from "../../../services/axios.services";

class MetricNineBoxesServices {
  getMetricNineBoxes = (params) =>
    AxiosClient.get("api/app/capacitacion_metrica_9_cajas/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveMetricNineBoxes = (data) =>
    AxiosClient.post("api/app/capacitacion_metrica_9_cajas/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMetricNineBoxes = (id, data) =>
    AxiosClient.put(`api/app/capacitacion_metrica_9_cajas/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteMetricNineBoxes = (id) =>
    AxiosClient.delete(`api/app/capacitacion_metrica_9_cajas/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MetricNineBoxesServices();
